import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { SavingGoalStoreModel } from "../../../../models/store/saving-goal.store.model";

export class SavingGoalParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported SavingGoal parser version ${version}`);
    }

    if (version === 0) {
      return SavingGoalParser_v0;
    }
    return SavingGoalParser_v0;
  }

  override getSupportedVersion(): number[] {
    return [0];
  }
}

const SavingGoalParser_v0 = (savingGoalItem: any): any => savingGoalItem as SavingGoalStoreModel;
